import React, { useEffect, useState } from "react";
import { notification, Spin } from "antd";
import DealCard from "./components/DealCard";
import PaginationWidget from "../../../widgets/PaginationWidget";
import ExclusiveDealsApi from "../../../api-services/exclusive-deals-api.service";
import { Deal } from "../../../interfaces/deal.interface";

const exclusiveDealsApi = new ExclusiveDealsApi();

// The "view all" destination for the homepage's Exclusive Deals carousel
// (see components/ExclusiveDeals), shown at /web/v2/exclusive-deals. Same
// ticket cards as the carousel, laid out in a responsive grid with real
// pagination instead of a horizontal scroll.
export default function ExclusiveDealsListing() {
  const [deals, setDeals] = useState<Deal[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    exclusiveDealsApi.getDeals(currentPage)
      .then(({ deals, totalPages }) => {
        setDeals(deals);
        setTotalPages(totalPages);
      })
      .catch(() => notification.error({ message: "Something went wrong while loading Exclusive Deals." }))
      .finally(() => setLoading(false));
  }, [currentPage]);

  return (
    <div id="deals-listing-v2">
      <div className="deals-listing-v2__content">
        <div className="deals-listing-v2__header">
          <h1>Exclusive Deals</h1>
          <p>Limited-time offers you shouldn't miss.</p>
        </div>
        <Spin size="large" className="loader" spinning={loading} />
        {!loading && (
          <div className="deals-listing-v2__grid">
            {deals.map((deal) => (
              <DealCard key={deal.id} deal={deal} />
            ))}
          </div>
        )}
        {!loading && totalPages > 1 && (
          <PaginationWidget totalItems={totalPages} current={currentPage} maxItemsPerPage={1} pageChange={setCurrentPage} />
        )}
      </div>
    </div>
  );
}
